import { MAX_GROUP_PARTICIPANTS } from './communicationRecipients.js';

export function validateConversationGroup(phones = []) {
    const list = [...new Set(Array.isArray(phones) ? phones : [])].sort();
    if (list.length < 2) return { valid: false, phones: list, error: 'A group needs at least two recipients.' };
    if (list.length > MAX_GROUP_PARTICIPANTS) return { valid: false, phones: list, error: 'Group MMS allows 10 participants including the company line: choose up to nine recipients. Send individually for larger lists.' };
    if (list.some((phone) => !/^\+1[2-9]\d{9}$/.test(phone) || /^\+1(?:800|833|844|855|866|877|888)/.test(phone))) return { valid: false, phones: list, error: 'Group MMS requires +1 US/Canada long-code numbers. Send individually to other numbers.' };
    return { valid: true, phones: list, error: '' };
}
export const groupConversationKey = (phones) => `group:${[...new Set(phones)].sort().join(',')}`;
